import React from 'react'
import * as UI from 'ui'
import * as Displays from 'support/displays'
import * as Columns from 'support/columns'
import { useCase, useValue, ValueToCollection, WhenCollectionIsNotEmpty } from '@morningtrain/react-resources'
import { Table } from 'widgets/crud'
import NormItemCategoryWeekdayColumns from './NormItemCategoryWeekdayColumns'
import NormItemRowAnchorId from 'pages/app/inventory/norms/NormItemRowAnchorId'

export default function NormItemCategory () {
  const keyValue = useValue('key')
  const caseValue = useCase()

  if (caseValue && caseValue !== keyValue) {
    return null
  }

  return (
    <UI.CardWithHeader header={<Displays.Text name='collection.0.category_name' />}>
      <ValueToCollection name='collection'>
        <WhenCollectionIsNotEmpty>
          <Table>
            <Columns.Column className='w-1/12'>
              <NormItemRowAnchorId />
              <UI.ProductInfo
                className='max-w-2xs'
                image={<Displays.Image name='image' className='h-full w-full object-contain block' lazy />}
                title={<Displays.Text name='name' />}
                text={(<>min. <Displays.Integer name='min_unit' /> <Displays.Text name='unit_type' /></>)}
              />
            </Columns.Column>
            <NormItemCategoryWeekdayColumns />
          </Table>
        </WhenCollectionIsNotEmpty>
      </ValueToCollection>
    </UI.CardWithHeader>
  )
}
